export const ROLES = Object.freeze({
  SUPERUSER: "Super User",
  CDVP: "CD VP",
  BRANCH_MANAGER: "Branch Manager",
  ASM: "Area Sales manager",
  SUPERVISOR: "Supervisor",
  TEAM_LEAD: "Team Leader",
  SALES_OFFICER: "Sales Officer",
});
